import { getComponentByProperty } from "../../../Components/Display/Components/utils";
import * as Events from "./ComponentsContextEvents";

export default function componentsReducer(state, action) {
    switch (action.type) {
        case Events.SET_COMPONENTS:
            return {
                ...state,
                components: prepareComponentsTree(action.payload)
            }
        case Events.ADD_COMPONENTS: {
            const newComponents = addComponentToTree(state.components, action.payload);
            const addedComponent = getComponentByProperty(newComponents, "id", action.payload.id);
            return {
                ...state,
                components: newComponents,
                selectedComponentIndex: addedComponent.treeIndex
            };
        }
        case Events.ADD_COMPONENTS_TO_FLAT_LIST: {
            const newComponents = [...state.components];
            action.payload.treeIndex = String(newComponents.length);
            newComponents.push(action.payload);
            return {
                ...state,
                components: newComponents
            }
        }
        case Events.DELETE_COMPONENT_TO_FLAT_LIST: {
            const newComponents = state.components.filter(component => component.id !== action.payload);
            return {
                ...state,
                components: newComponents
            }
        }
        case Events.TOGGLE_ADD_COMPONENT_DIALOG:
            return {
                ...state,
                showAddComponentDialog: !state.showAddComponentDialog,
                newComponentParentId: action?.payload?.parentId
            }
        case Events.SET_SELECTED_COMPONENT:
            return {
                ...state,
                selectedComponentIndex: action.payload
            }
        case Events.TOGGLE_EXPAND:
            return {
                ...state,
                components: toggleExpandForComponent(state.components, action.payload)
            }
        case Events.TOGGLE_CONTEXT_MENU:
            return {
                ...state,
                showContextMenu: !state.showContextMenu,
                contextMenuOffset: action.payload.offset,
                contextMenuItemIndex: !state.showContextMenu ? action.payload.index : ""
            }
        case Events.TOGGLE_DELETE_COMPONENT_DIALOG:
            return {
                ...state,
                showDeleteComponentDialog: !state.showDeleteComponentDialog,
                deletedComponentIndex: !state.showDeleteComponentDialog ? action.payload : null
            }
        case Events.DELETE_COMPONENT: {
            debugger;
            const components = removeComponentFromTree(state.components, action.payload).map((component, index) => ({
                ...component,
                treeIndex: String(index)
            }));
            if (components.length === 0) {
                return {
                    ...state,
                    components,
                    selectedComponentIndex: ""
                }
            }
            const currentSelectedIndexArr = state.selectedComponentIndex.split("_").map(Number);
            let nextSelectedIndex;
            if (currentSelectedIndexArr.length === 1) {
                if (currentSelectedIndexArr[0] > 0) {
                    nextSelectedIndex = String(currentSelectedIndexArr[0]--);
                }
            } else {
                let parent = components[currentSelectedIndexArr[0]];
                for (let index = 1; index < currentSelectedIndexArr.length - 1; index++) {
                    parent = parent.children[index];
                }
                if (parent.children && parent.children.length > 0) {
                    let componentIndex = currentSelectedIndexArr[currentSelectedIndexArr.length - 1];
                    if (componentIndex > 0) {
                        componentIndex--;
                    }
                    nextSelectedIndex = parent.treeIndex + "_" + componentIndex;
                } else {
                    nextSelectedIndex = parent.treeIndex
                }
            }
            return {
                ...state,
                components,
                selectedComponentIndex: nextSelectedIndex
            }
        }
        case Events.TOGGLE_COMPONENT_ENABLE_DISABLE_DIALOG:
            return {
                ...state,
                showComponentEnableDisableDialog: !state.showComponentEnableDisableDialog,
            }
        case Events.TOGGLE_COMPONENT_HIDDEN:
            return {
                ...state,
                components: toggleComponentHiddenState(state.components, action.payload)
            }
        case Events.TOGGLE_RESET_COMPONENT_DIALOG:
            return {
                ...state,
                showResetComponentDialog: !state.showResetComponentDialog
            }
        default:
            return state;
    }
}

function prepareComponentsTree(components, parentId = "") {
    const componentsTree = [];
    for (let index = 0; index < components.length; index++) {
        const component = components[index];
        component.text = component.componentName;
        component.expanded = true;
        component.treeIndex = parentId === "" ? `${index}` : `${parentId}_${index}`;
        if (component.children && component.children.length > 0) {
            component.children = prepareComponentsTree(component.children, component.treeIndex);
        }
        componentsTree.push(component);
    }
    return componentsTree;
}

export function addComponentToTree(components, newComponent) {
    if (newComponent.parentId === newComponent.pageId) {
        return [
            ...components,
            {
                ...newComponent,
                text: newComponent.componentName,
                treeIndex: String(components.length),
                children: newComponent.children ? newComponent.children.map((child, childIndex) => ({
                    ...child,
                    text: child.componentName,
                    treeIndex: `${components.length}_${childIndex}`
                }))
                    :
                    newComponent.children
            }
        ]
    }
    if (components.length > 0 && newComponent.parentId === components[0].parentId) {
        return [
            ...components,
            {
                ...newComponent,
                text: newComponent.componentName,
                treeIndex: `${components.length}`,
                children: newComponent.children ? newComponent.children.map((child, childIndex) => ({
                    ...child,
                    text: child.componentName,
                    treeIndex: `${components.length}_${childIndex}`
                }))
                    :
                    newComponent.children
            }
        ]
    }
    return components.map((component, index) => {
        if (component.id === newComponent.parentId) {
            if (!component.children) {
                component.children = [];
            }
            return {
                ...component,
                children: [
                    ...component.children,
                    {
                        ...newComponent,
                        text: newComponent.componentName,
                        treeIndex: `${component.treeIndex}_${component.children.length}`,
                        children: newComponent.children ? newComponent.children.map((child, childIndex) => ({
                            ...child,
                            text: child.componentName,
                            treeIndex: `${components.length}_${childIndex}`
                        }))
                            :
                            newComponent.children
                    }
                ]
            }
        }
        if (component.children) {
            component.children = addComponentToTree(component.children, newComponent);
        }
        return component;
    })
}

function toggleExpandForComponent(components, componentId) {
    return components.map(component => {
        if (component.treeIndex === componentId) {
            return {
                ...component,
                expanded: !component.expanded
            }
        }
        if (component.children) {
            component.children = toggleExpandForComponent(component.children, componentId);
        }
        return component;
    })
}

export function removeComponentFromTree(components, componentId) {
    for (let componentIndex = 0; componentIndex < components.length; componentIndex++) {
        const component = components[componentIndex];
        if (component.treeIndex === componentId) {
            return components.filter(component => component.treeIndex !== componentId);
        } else if (component.children) {
            component.children = removeComponentFromTree(
                component.children,
                componentId
            ).map((child, index) => ({
                ...child,
                treeIndex: `${component.treeIndex}_${index}`,
            }));
        }
    }
    return components;
}

function toggleComponentHiddenState(components, treeIndex) {
    return components.map(component => {
        if (component.treeIndex === treeIndex) {
            return {
                ...component,
                hidden: !component.hidden,
                children: component.children ? toggleComponentChildrenHiddenState(component.children, !component.hidden) : component.children
            }
        } else if (component.children) {
            component.children = toggleComponentHiddenState(component.children, treeIndex);
        }
        return component;
    })
}

function toggleComponentChildrenHiddenState(components, parentHidden) {
    return components.map(component => {
        return {
            ...component,
            hidden: parentHidden,
            children: component.children ? toggleComponentChildrenHiddenState(component.children, parentHidden) : component.children
        }
    });
}